import axios from 'axios';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import auth from '../../../libCustom/auth';
import WidgetSearchName from '../../Clients/widget-searchName';
import * as SalesActions from '../redux/SalesActions';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import * as rdrLocales from 'react-date-range/src/locale';
import Switch from 'react-switch';
import Checkbox from 'components/CustomCheckbox/CustomCheckbox.jsx';

import {
  calendarDayToUtc,
  utcToCalendarDay,
} from '../../../libCustom/travelDates';

const options = [
  { value: 'Nacional', label: 'Nacional' },
  { value: 'Internacional', label: 'Internacional' },
];

const options1 = [
  { value: 'F', label: 'Factura' },
  { value: 'VTA', label: 'Nota de Venta' },
];

let people = [];
for (let i = 0; i <= 100; i++) {
  people.push({ value: i, label: i });
}

class salesInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsSelect: {
        clients: [],
        status: [],
        users: [],
      },
      forcedSale: false,
      minDateState: new Date(),
    };
  }

  componentWillMount() {
    let startDate = moment(this.props.Sales.salesInformation.departureDate);
    let endDate = moment(this.props.Sales.salesInformation.returnDate);

    const diff = endDate.diff(startDate, 'days');

    this.setState({
      days: diff,
    });

    const franchiseId = auth.getCurrentUser().franchiseId;
    const params = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
      where: {
        franchiseId: franchiseId,
        isDeleted: { neq: true },
      },
    };
    this.getOptionsSelect(
      'users',
      process.env.REACT_APP_URL_API +
      '/api/users?filter=' +
      JSON.stringify(params),
      (option) => {
        return {
          label: option.firstName + ' ' + option.lastName,
          value: option.id,
        };
      },
    );
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    var response = await axios.get(url);
    var options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });

    options.sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();
      return labelA.localeCompare(labelB);
    });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
      clients: response.data,
    });
  };

  onChangeWidgetSearch = async (value) => {
    var newClientInformation = immutable.set(
      this.props.Sales,
      'clientId',
      value,
    );
    this.props.dispatch(SalesActions.setState(newClientInformation));
  };

  onCreateWidgetSearch = () => {
    window.open('/#/admin/clients/create', '_blank');
  };

  handleRangeChange = (payload) => {
    let endDate = calendarDayToUtc(payload.selection.endDate);
    let startDate = calendarDayToUtc(payload.selection.startDate);

    const diff = endDate.diff(startDate, 'days');

    this.props.dispatch(
      SalesActions.onChange(['salesInformation', 'returnDate'], endDate),
    );
    this.props.dispatch(
      SalesActions.onChange(['salesInformation', 'departureDate'], startDate),
    );
    this.props.dispatch(
      SalesActions.onChange(['salesInformation', 'duration'], diff),
    );

    this.setState({
      days: diff,
    });
  };

  handleChange(id, checked) {
    if (checked === true) {
      this.setState({
        forcedSale: true,
        minDateState: new Date(2018, 10 - 1, 25),
      });
    } else {
      this.setState({
        forcedSale: false,
        minDateState: new Date(),
      });
    }

    this.props.dispatch(
      SalesActions.onChange(['salesInformation', id], checked),
    );
  }

  render() {
    let { Sales } = this.props;
    let { optionsSelect } = this.state;

    return (
      <div>
        <Row>
          <Col md={6}>
            <label
              className="checkbox-inline"
              style={{ marginTop: '6px', padding: 0 }}
            >
              <Checkbox
                style={{ color: '#000', fontWeight: 'bold' }}
                number="99"
                label="Paquete"
                checked={Sales.salesInformation.isPackage}
                onChange={(event) =>
                  this.props.dispatch(
                    SalesActions.onChange(
                      ['salesInformation', 'isPackage'],
                      event.target.checked,
                    ),
                  )
                }
              />
            </label>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="client">Asignado a</label>

              <Select
                id="clientId"
                placeholder="-- Seleccionar"
                name="clientId"
                value={Sales.assignedTo}
                options={
                  optionsSelect.users.length > 0
                    ? optionsSelect.users
                    : Sales.assignedTo._id !== undefined
                      ? [Sales.assignedToDefault]
                      : []
                }
                onChange={(value) => {
                  if (value) {
                    this.props.dispatch(
                      SalesActions.onChange(['assignedTo'], value.value),
                    );
                  } else {
                    this.props.dispatch(
                      SalesActions.onChange(['assignedTo'], ''),
                    );
                  }
                }}
              />
              <input
                style={{
                  height: 1,
                  padding: 0,
                  margin: 0,
                  border: 0,
                  color: 'white',
                }}
                required
                type="text"
                id="userIdHidden"
                value={Sales.assignedTo}
                onChange={() => { }}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <div>
                <label htmlFor="limitDate" style={{ fontWeight: '600' }}>
                  {Sales &&
                    Sales.salesInformation &&
                    Sales.salesInformation.limitDateColor === 'Red' ? (
                    <i class="fa fa-circle" style={{ color: '#FF0000' }} />
                  ) : Sales &&
                    Sales.salesInformation &&
                    Sales.salesInformation.limitDateColor === 'Yellow' ? (
                    <i class="fa fa-circle" style={{ color: '#ffff00' }} />
                  ) : (
                    ''
                  )}
                  FECHA LÍMITE DE PAGO
                </label>
                <input
                  className="form-control"
                  id="limitDate"
                  value={
                    Sales &&
                      Sales.salesInformation &&
                      Sales.salesInformation.limitDate
                      ? moment(Sales.salesInformation.limitDate)
                        .utc()
                        .format('YYYY-MM-DD')
                      : ''
                  }
                  onChange={(event) =>
                    this.props.dispatch(
                      SalesActions.onChange(
                        ['salesInformation', 'limitDate'],
                        event.target.value,
                      ),
                    )
                  }
                  max={
                    Sales &&
                      Sales.salesInformation &&
                      Sales.salesInformation.departureDate
                      ? moment.utc(Sales.salesInformation.departureDate)
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                      : ''
                  }
                  type="date"
                  required
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="client">Cliente</label>
              <WidgetSearchName
                schema={{
                  creatable: false,
                  title: 'Buscar cliente por nombre, telefono o correo',
                  api: process.env.REACT_APP_URL_API + '/api/clients',
                }}
                value={Sales.clientId}
                defaultOptions={
                  Sales.clientDefault._id !== undefined
                    ? [
                      {
                        value: Sales.clientDefault._id,
                        label: Sales.clientDefault.firstName,
                      },
                    ]
                    : []
                }
                required={true}
                onChange={this.onChangeWidgetSearch}
                onCreate={this.onCreateWidgetSearch}
              />

              <input
                style={{
                  height: 1,
                  padding: 0,
                  margin: 0,
                  border: 0,
                  color: 'white',
                }}
                required
                type="text"
                id="userIdHidden"
                value={Sales.clientId}
                readOnly={true}
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="saleStatus">Estatus de venta</label>
              <Select
                id="clientId"
                placeholder="-- Seleccionar"
                name="statusId"
                defaultValue={'VTA'}
                value={Sales.salesInformation.statusId}
                options={options1}
                disabled={this.props.currentId !== 'create'}
                onChange={(value) => {
                  if (value) {
                    this.props.dispatch(
                      SalesActions.onChange(
                        ['salesInformation', 'statusId'],
                        value.value,
                      ),
                    );
                  } else {
                    this.props.dispatch(
                      SalesActions.onChange(
                        ['salesInformation', 'statusId'],
                        '',
                      ),
                    );
                  }
                }}
              />
              <input
                style={{
                  height: 1,
                  padding: 0,
                  margin: 0,
                  border: 0,
                  color: 'white',
                }}
                required
                type="text"
                id="userIdHidden"
                value={Sales.salesInformation.statusId}
                onChange={() => { }}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="reference">Destino</label>
              <input
                type="text"
                className="form-control"
                id="destination"
                required={true}
                value={Sales.salesInformation.destination}
                onChange={(event) =>
                  this.props.dispatch(
                    SalesActions.onChange(
                      ['salesInformation', 'destination'],
                      event.target.value,
                    ),
                  )
                }
              />
            </div>
          </Col>
          <Col md={3}>
            <div className="form-group">
              <label htmlFor="reference">Forzar fecha de venta</label>
              <div>
                <Switch
                  id="forcedSale"
                  checked={Sales.salesInformation.forcedSale}
                  onChange={(checked) =>
                    this.handleChange('forcedSale', checked)
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
        {/* //DONE Paty - Hacer un checbox para indicar que es "Venta Forzada" y que al dar click ahí cambie la propiedad "minDate" del componente "DateRange" para que quede libre el calendario de seleccionar dias anteriores.  */}
        <Row>
          <Col md={12}>
            {!this.state.openDateDisabled ? (
              <DateRange
                onChange={this.handleRangeChange}
                moveRangeOnFirstSelection={false}
                months={2}
                direction="horizontal"
                locale={rdrLocales['es']}
                minDate={this.state.minDateState}
                ranges={[
                  {
                    startDate:
                      this.props.Sales.salesInformation.departureDate !== '' &&
                        this.props.Sales.salesInformation.departureDate !==
                        undefined
                        ? utcToCalendarDay(
                          this.props.Sales.salesInformation.departureDate,
                        )
                        : moment(),
                    endDate:
                      this.props.Sales.salesInformation.returnDate !== '' &&
                        this.props.Sales.salesInformation.returnDate !== undefined
                        ? utcToCalendarDay(this.props.Sales.salesInformation.returnDate)
                        : moment(),
                    key: 'selection',
                  },
                ]}
                className={'PreviewArea'}
              />
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <div className="form-group">
              <label htmlFor="duration">Duración (noches)</label>
              <input
                id="activityInput"
                className="form-control"
                rows="1"
                value={this.state.days}
                disabled
                name="body"
                type="number"
              />
            </div>
          </Col>
        </Row>
        <div className="form-group">
          <label htmlFor="reference">Interés</label>
          <Select
            placeholder="-- Seleccionar"
            name="interest"
            required
            options={options}
            value={Sales.salesInformation.interest}
            onChange={(event) => {
              if (event) {
                this.props.dispatch(
                  SalesActions.onChange(
                    ['salesInformation', 'interest'],
                    event.value,
                  ),
                );
              } else {
                this.props.dispatch(
                  SalesActions.onChange(['salesInformation', 'interest'], ''),
                );
              }
            }}
          />

          <input
            style={{
              height: 1,
              padding: 0,
              margin: 0,
              border: 0,
              color: 'white',
            }}
            required
            type="text"
            id="userIdHidden"
            value={Sales.salesInformation.interest}
            readOnly={true}
          />
        </div>
        <Row>
          <Col md={4}>
            <div className="form-group">
              <label htmlFor="reference">Adultos (Mayor a 18 años)</label>
              <Select
                placeholder="-- Seleccionar"
                name="adults"
                value={Sales.salesInformation.adults}
                options={people}
                onChange={(event) => {
                  if (event) {
                    this.props.dispatch(
                      SalesActions.onChange(
                        ['salesInformation', 'adults'],
                        event.value,
                      ),
                    );
                  } else {
                    this.props.dispatch(
                      SalesActions.onChange(['salesInformation', 'adults'], ''),
                    );
                  }
                }}
              />
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <label htmlFor="reference">Juniors (13-17 años)</label>
              <Select
                placeholder="-- Seleccionar"
                name="juniors"
                value={Sales.salesInformation.juniors}
                options={people}
                onChange={(event) => {
                  if (event) {
                    this.props.dispatch(
                      SalesActions.onChange(
                        ['salesInformation', 'juniors'],
                        event.value,
                      ),
                    );
                  } else {
                    this.props.dispatch(
                      SalesActions.onChange(
                        ['salesInformation', 'juniors'],
                        '',
                      ),
                    );
                  }
                }}
              />
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <label htmlFor="reference">Niños (0-12 años)</label>
              <Select
                isClearable
                placeholder="-- Seleccionar"
                name="kids"
                value={Sales.salesInformation.kids}
                options={people}
                onChange={(event) => {
                  if (event) {
                    this.props.dispatch(
                      SalesActions.onChange(
                        ['salesInformation', 'kids'],
                        event.value,
                      ),
                    );
                  } else {
                    this.props.dispatch(
                      SalesActions.onChange(['salesInformation', 'kids'], ''),
                    );
                  }
                }}
              />
            </div>
          </Col>
        </Row>{' '}
        <div className="form-group">
          <label htmlFor="reference">Observaciones del cliente</label>
          <textarea
            type="text"
            className="form-control"
            id="notes"
            value={Sales.salesInformation.notes}
            onChange={(event) =>
              this.props.dispatch(
                SalesActions.onChange(
                  ['salesInformation', 'notes'],
                  event.target.value,
                ),
              )
            }
          />
        </div>
        {/*PROBAR EL VALUE DE LAS VENTAS*/}
        <div className="form-group">
          <label htmlFor="trackingLine">Línea de Seguimiento</label>
          <textarea
            type="text"
            className="form-control"
            id="trackingNotes"
            value={Sales.salesInformation.trackingLine}
            onChange={(event) =>
              this.props.dispatch(
                SalesActions.onChange(
                  ['salesInformation', 'trackingLine'],
                  event.target.value,
                ),
              )
            }
          />
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(salesInformation);



// WEBPACK FOOTER //
// ./src/views/Sales/cards/saleInformation.js